import {
    LATEST_ARTICLES_SUCCESS,
    LATEST_ARTICLES_FAILURE,
} from '../actions/types';

const defaultLatestArticlesState = () => ({
    latest: [],
    error: false,
});

/* eslint-disable import/prefer-default-export */
export const fetchLatestArticlesReducer = (state = defaultLatestArticlesState(), action) => {
    if (action.type === LATEST_ARTICLES_SUCCESS) {
        return {
            ...state,
            latest: [...action.payload],
        };
    }

    if (action.type === LATEST_ARTICLES_FAILURE) {
        return {
            ...state,
            ...action.payload,
            error: true,
        };
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/latest-articles.js
 **/